import React from 'react';
import DOMPurify from 'dompurify';
import { Box } from '@mui/material';

const SanitizedHtmlRenderer = ({ htmlContent }) => {
    if (!htmlContent) {
        return null;
    }

    // Sanitize the HTML string to prevent XSS attacks
    const sanitizedHtml = DOMPurify.sanitize(htmlContent);

    return (
        <Box
            // --- FIX START: CSS for Responsive Text & Images ---
            sx={{
                // 1. Force long words/urls to break to the next line
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                
                // 2. Ensure nested elements don't overflow width
                maxWidth: '100%',

                // 3. Make images responsive (scale down if too big)
                '& img': {
                    maxWidth: '100%', 
                    height: 'auto',    
                    borderRadius: '4px',
                    display: 'block',
                    my: 1
                },
                
                // 4. Fix table overflow if questions contain tables
                '& table': {
                    display: 'block',
                    width: '100%',
                    overflowX: 'auto',
                },
                
                // 5. Basic typography spacing
                '& p': {
                    marginTop: 0,
                    marginBottom: '0.5rem',
                }
            }}
            // --- FIX END ---
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
    );
};

export default SanitizedHtmlRenderer;
